import { IStaff } from "@/interfaces/Istaff";
import { FiPhone, FiGlobe } from "react-icons/fi";

interface AboutTabProps {
  staff: IStaff;
}

// Helper to get today's working hours string
function getTodayWorkingHours(profile: any): string | null {
  const days = ["su", "mo", "tu", "we", "th", "fr", "sa"];
  const todayIdx = new Date().getDay();
  const todayKey = days[todayIdx];
  const wh = profile.working_hours?.[todayKey];
  if (!wh || !wh.shifts || wh.shifts.length === 0) return null;
  // Only show first shift for simplicity
  const shift = wh.shifts[0];
  const format = (m: number) => {
    const h = Math.floor(m / 60);
    const min = m % 60;
    const ampm = h >= 12 ? "PM" : "AM";
    const hour = h % 12 === 0 ? 12 : h % 12;
    return `${hour}:${min.toString().padStart(2, "0")} ${ampm}`;
  };
  return `${format(shift.start)}  -  ${format(shift.end)}`;
}

export default function AboutTab({ staff }: AboutTabProps) {
  const { profile, email } = staff;
  const todayHours = getTodayWorkingHours(profile);
  return (
    <div className="p-4">
      <div className="space-y-3">
        {profile.phones && profile.phones[0] && (
          <div className="flex items-center gap-2">
            <span className="text-green-600">
              <FiPhone size={18} />
            </span>
            <span className="text-green-600 font-medium">
              {profile.phones[0]}
            </span>
          </div>
        )}
        <div className="flex items-center gap-2">
          <span>
            <svg width="18" height="18" fill="none" viewBox="0 0 24 24">
              <path stroke="currentColor" strokeWidth="2" d="M4 4h16v16H4V4Z" />
              <path stroke="currentColor" strokeWidth="2" d="M4 4l8 8 8-8" />
            </svg>
          </span>
          <span>{email}</span>
        </div>
        {profile.role && (
          <div className="flex items-center gap-2">
            <span>
              <svg width="18" height="18" fill="none" viewBox="0 0 24 24">
                <circle
                  cx="12"
                  cy="12"
                  r="10"
                  stroke="currentColor"
                  strokeWidth="2"
                />
                <path stroke="currentColor" strokeWidth="2" d="M12 16v-4" />
                <circle cx="12" cy="8" r="1" fill="currentColor" />
              </svg>
            </span>
            <span>{profile.role}</span>
          </div>
        )}
        {profile.about && (
          <div className="flex items-center gap-2">
            <span>
              <svg width="18" height="18" fill="none" viewBox="0 0 24 24">
                <path
                  stroke="currentColor"
                  strokeWidth="2"
                  d="M4 4h16v16H4V4Z"
                />
                <path stroke="currentColor" strokeWidth="2" d="M4 4l8 8 8-8" />
              </svg>
            </span>
            <span>{profile.about}</span>
          </div>
        )}
        {profile.social_links && profile.social_links.website && (
          <div className="flex items-center gap-2">
            <span className="text-green-600">
              <FiGlobe size={18} />
            </span>
            <a
              href={profile.social_links.website}
              className="text-green-600 underline"
              target="_blank"
              rel="noopener noreferrer"
            >
              {profile.social_links.website}
            </a>
          </div>
        )}
        {todayHours && (
          <div className="flex items-center gap-2">
            <span>
              <svg width="18" height="18" fill="none" viewBox="0 0 24 24">
                <circle
                  cx="12"
                  cy="12"
                  r="10"
                  stroke="currentColor"
                  strokeWidth="2"
                />
                <path stroke="currentColor" strokeWidth="2" d="M12 6v6l4 2" />
              </svg>
            </span>
            <span>
              Today&nbsp;
              {todayHours}
            </span>
          </div>
        )}
      </div>
    </div>
  );
}
